
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateNote",
      resolverType: "mutation",
      routePath: "/updateNote",
      httpMethod: "POST",
    });
  